import { combineEpics } from "redux-observable";
import fetchUsers from "./fetchUsers";
import fetchAvatars from "./fetchAvatars";
import loadAPI from "./loadAPI";
import onAPILoaded from "./onAPILoaded";
import fetchCBook from "./fetchCBook";
import fetchContent from "./fetchContent";
import getCompleted from "./getCompleted";
import fetchClaims from "./fetchClaims";
import onNav from "./onNav";
import setCompleted from "./setCompleted";
import fetchBonusMaterial from "./fetchBonusMaterial";
import beginLMSSession from "./beginLMSSession";
import setSuspendData from "./setSuspendData";
import setProgress from "./setProgress";
import getKeyValueStore from "./getKeyValueStore";
import getFavorites from "./getFavorites";
import fetchLocale from "./fetchLocale";
import fetchSearchableSlides from "./fetchSearchableSlides";
import doSearch from "./doSearch";
import fetchRating from "./fetchRating";
import updateRating from "./updateRating";
import login from "./login";
import fetchSocialConfig from "./fetchSocialConfig";
import endorseDisclaimer from "./endorseDisclaimer";
import getTweetVersion from "./getTweetVersion";
import fetchGroups from "./fetchGroups";
import fetchExamInteractions from "./fetchExamInteractions";
import onEvalInteractions from "./onEvalInteraction";
import getExamData from "./getExamData";
import onExamStart from "./onExamStart";
import setCourseStatus from "./setCourseStatus";
import fetchSocialChartData from "./fetchSocialChartData";
import updateSocialChartData from "./updateSocialChartData";
import updateGroup from "./updateGroup";
import createGroup from "./createGroup";
import fetchAllTopics from "./fetchAllTopics";
import fetchSingleTopic from "./fetchSingleTopic";
import fetchNotes from "./fetchNotes";
import fetchPrintNotes from "./fetchPrintNotes";
import deleteNote from "./deleteNote";
import fetchSingleNote from "./fetchSingleNote";
import fetchActivity from "./fetchActivity";
import uploadActivityFile from "./uploadActivityFile";
import onSelectSearchedTopic from "./onSelectSearchedTopic";
import searchTopics from "./searchTopics";
import fetchCommunityChartData from "./fetchCommunityChartData";
import toggleGroupVisibility from "./toggleGroupVisibility";
export default combineEpics(fetchUsers, fetchAvatars, loadAPI, onAPILoaded, fetchCBook, fetchContent, getCompleted, setCompleted, fetchClaims, onNav, fetchBonusMaterial, beginLMSSession, setSuspendData, setProgress, getKeyValueStore, getFavorites, fetchLocale, fetchSearchableSlides, doSearch, updateRating, fetchRating, login, fetchSocialConfig, endorseDisclaimer, getTweetVersion, fetchGroups, fetchExamInteractions, onEvalInteractions, getExamData, onExamStart, setCourseStatus, fetchSocialChartData, updateSocialChartData, updateGroup, createGroup, fetchAllTopics, fetchSingleTopic, fetchNotes, fetchPrintNotes, deleteNote, fetchSingleNote, fetchActivity, uploadActivityFile, onSelectSearchedTopic, searchTopics, fetchCommunityChartData, toggleGroupVisibility);
